import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import ProductReceived from "./ProductReceived";
import Routes from '../../routes';
import {fetchPurchasesList, chargeAuctionWinPurchases, setAuctionServerUpdate, setDealsServerUpdate, setRaffleServerUpdate } from "../../actions/products";
import BidReceivedModal from '../../components/BidReceivedModal';
import BidReceived from '../../pages/BidReceived';
import history from '../../history';



import app from "../../base";

import {BidLogo, Utils} from "../../components/BidComponents";
import CustomButton from '../../components/CustomButton';
import moment from 'moment/moment.js';

class HomeContainer extends Component {
  modalClose = () => {
    const {history} = this.props;

    history.push(Routes.main);
  };

  modalBidAgain = () => {
    
    const {history, match: {params}} = this.props;
    const {type, id} = params;

    history.push(`${Routes.productPage}/${type}/${id}`);
  };


getReceivedHead = (productOffer,product) => {
  // const {match: {params}} = this.props
    //const {productOffer,product} = params;

    let result = 'got it!';
    const expired = this.getExpiredTime(product);
   
     //console.log("Product phoneNumber", productOffer);
      //console.log("Raffle Winner", product);
 
   if (!expired) { switch(productOffer.type) {
      case 'auction':
        productOffer.charged = false;
        result = 'bid sent';
        break;
      case 'raffle':
        result = 'entry received';
        break;
      default:
        result = 'got it!';
    } } else {
    switch(productOffer.type) {
      case 'auction':
           //console.log("Product in BidReceivedModal", parseInt(product.currentBidValue));
           //console.log("ProductOffer in BidReceivedModal", productOffer.bidMax);
        result =  (productOffer.bidMax === parseInt(product.currentBidValue) && productOffer.bidMax >= parseInt(product.reserveBidValue) ) ? 'YOU WON!':'you did not win this auction.';

        break;
      case 'raffle':
        console.log("Product in BidReceivedModal", product.raffleWinner);
        console.log("ProductOffer in BidReceivedModal", productOffer.phoneNumber);
        result = productOffer.phoneNumber === product.raffleWinner ? 'YOU WON!':'Try again next time!';
        break;

      case 'deals':
        result = 'Got it!'
        break;

    
      default:
        result = 'Try Again!';
    } }

    return result;
  };

  getReceivedSubHead = (productOffer, product) => {
     //const {match: {params}} = this.props
    //const {productOffer} = params;
    const expired = this.getExpiredTime(product);
    let result = 'We got your bid. You\'ll be notified about the results of the auction shortly!';

    if (!expired) { 
        switch (productOffer.type) {
          case 'raffle':
            result = '';
            break;
          case 'deals':
            result = 'Thank you for your purchase. Please see the host to redeem your item!';
            break;
          default:
            result = 'We got your bid. You\'ll be notified about the results of the auction shortly!';
        }
    }else{
        switch (productOffer.type) {
          case 'raffle':
            result = '';
            break;
          case 'deals':
            result = 'Thank you for your purchase. Please see the host to redeem your item!';
            break;
          default:
            result = 'We\'ve received your bid!';
         }
  }
    return result;
  };

  getExpiredTime = (product) => {
    //const {product} = this.props;
    const endTimeMoment = moment(product.endTime, 'YYYY-MM-DD HH:mm:ss');
    const currMoment = moment().format('YYYY-MM-DD HH:mm:ss');
 
    //console.log("PRODUCT ENDTIME:",product.endTime);
    // console.log("Moment CurrTime:",currMoment);
    let result = endTimeMoment.isAfter(moment(currMoment ,'YYYY-MM-DD HH:mm:ss')) ? false : true

    return result;
  };

  getReceivedInfo = (productOffer, product) => {
    //const {productOffer, product} = this.props;

     //console.log("BIDRECEIVEDINDEX productOffer:",productOffer);
     // console.log("BIDRECEIVEDINDEX product:",product);

    let result = `${productOffer.bid ? productOffer.bid : 1} purchased`;

    if (productOffer.type === 'auction')
      result = `your bid: $${productOffer.bid}`;

    return result;
  };

  getReceivedButtonName = (productOffer,product) => {
    //const {productOffer} = this.props;
    const expired = this.getExpiredTime(product);

    let result = 'buy again';

    if (productOffer.type === 'auction')
      result = `bid again`;

    if (expired)
      result = `Ended`;

    return result;
  };




  render() {
    const { auction, raffle, deals, purchases, match:{params} } = this.props;
    const {pageType, type, id} = params;
    //const {getTimeBought, getTimeBid} = this.props;

    console.log("ProductRECEIVEDPAGEINDEX");
    let products;

    switch (type) {
      case 'auction':
        products = auction;
        break;
      case 'raffle':
        products = raffle;
        break;
      case 'deals':
        products = deals;
        break;
      default: {
        products = [];
      }
    }

    if (!products.length) {
       console.log("ProductRECEIVEDPAGEtoMain");
      return (
        <Redirect to={Routes.main} />
      )
    }

    const product = products.filter(elem => {
      return elem.id === id
    })[0];

    const purchase = purchases.filter(elem => {
       return elem.type === type && elem.id === id;
    })[0];
    

    if (pageType === 'purchase') {
      if (!purchase) {
         console.log("ProductRECEIVEDPAGEtoPRODUCT");
        return (
          <Redirect to={`${Routes.productPage}/${type}/${id}`} />
        )
      } else if (!purchase.state || purchase.state === "charged"){
          const productOffer = {
            type,
            id,
            bid: purchase.type !== 'auction' ? purchase.quantity : purchase.bidAmount,
            bidMax: purchase.type === 'auction' && purchase.bidMax ? purchase.bidMax: purchase.bidAmount,
            phoneNumber: app.auth().currentUser.phoneNumber
          };
          console.log("ProductRECEIVEDPAGEtoBIDRECEIVEDMODAL no state or charged");
          console.log("productOffer", productOffer);
          console.log("product", product);
          console.log("purchase", purchase);
          //modalClose={this.modalClose}
            //  modalBidAgain={this.modalBidAgain}
          return (

      <div className="modal-wrapper">
        <div className="modal-content">
          <div className="bid-modal">
            <div className="bid-modal-topline">
              <div className="modal-close"
                   onClick={this.modalClose}
              >
                <i className="fas fa-times" />
              </div>
            </div>
            <div className="bid-modal-wrapper">
              <div className="bid-modal-head">
                {this.getReceivedHead(productOffer,product)}
              </div>
              <div className="bid-modal-subhead">
                {this.getReceivedSubHead(productOffer,product)}
              </div>
              <div className="bid-modal-content">
                <div className="bid-modal-cover">
                  <img src={Utils.getProductImage(productOffer.type, product)} alt=""/>
                </div>
                <div className="bid-modal-info">
                  <BidLogo
                    link={product.sellerImage}
                  />
                  <div className="bid-modal-title">
                    <h2 className="bid-card-title">{product.title}</h2>
                    <h3 className="bid-card-subtitle">{this.getReceivedInfo(productOffer,product)}</h3>
                  </div>
                </div>
              </div>
              <div className="bid-modal-describe">
                <span>{productOffer.type == 'auction' ? Utils.getTimeBid(purchase.purchaseTime): Utils.getTimeBought(purchase.purchaseTime)}</span>
                <p>{product.description}
                  <br/><br/><br/><br/>
                </p>
              </div>
                <div className="bid-modal-control">
                  <CustomButton
                    disabled = {this.getExpiredTime(product)}
                    onClick={this.modalBidAgain}
                    className="bid-modal-button"
                    text={this.getReceivedButtonName(productOffer,product)}
                  />
                </div>
            </div>
          </div>
        </div>
      </div>



            ///<Redirect to={`${Routes.productPage}/${type}/${id}`} />
            //<Redirect to={`${Routes.bidReceived}`} />
              
               /* <div className="container">
                    <div className="header">
                        <BackButton />
                    </div>
                </div>*/
          

            ////<BidReceivedModal
             // productOffer={productOffer}
             // product={product}
            ///>

       //<div>
    
        //<BidReceivedModal
         // receivedType={product.state}
          //productOffer={productOffer}
          //product={product}
          //modalClose={this.modalClose}
        ///>
      //</div>


          )
      }
    } else {
     /* const productOffer = {
      type,
      id,
      bid: purchase.type !== 'auction' ? purchase.quantity : purchase.bidAmount,
      bidMax: purchase.type === 'auction' && purchase.bidMax ? purchase.bidMax: purchase.bidAmount,
      phoneNumber: app.auth().currentUser.phoneNumber
      };*/
      if (!purchase || !purchase.state) { 
        console.log("ProductRECEIVEDPAGEtoPRODUCT no purchase and no purchase state");
        console.log("Type ", type);
        console.log("ID ", id);
        return (
          <Redirect to={`${Routes.productPage}/${type}/${id}`} />
           /*<ProductReceived
            product={product}
            productOffer={productOffer}
            modalClose={this.modalClose}
          />*/
        )
      }
    }

    const productOffer = {
      type,
      id,
      bid: purchase.type !== 'auction' ? purchase.quantity : purchase.bidAmount,
      bidMax: purchase.type === 'auction' && purchase.bidMax ? purchase.bidMax: purchase.bidAmount,
      phoneNumber: app.auth().currentUser.phoneNumber
    };

    if (purchase.state) {
      product.state = purchase.state;
    }

    return (
      <ProductReceived
        product={product}
        productOffer={productOffer}
        modalClose={this.modalClose}
      />
    )
  }
}

const mapStateToProps = ({products}) => {
  return {
    auction: products.auction,
    raffle: products.raffle,
    deals: products.deals,
    purchases: products.purchases
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPurchasesList: () => {dispatch(fetchPurchasesList())}, 
    chargeAuctionWinPurchases: (...props) => {dispatch(chargeAuctionWinPurchases(...props))},
    setAuctionServerUpdate: (...props) => {dispatch(setAuctionServerUpdate(...props))},
    setDealsServerUpdate: (...props) => {dispatch(setDealsServerUpdate(...props))},
    setRaffleServerUpdate: (...props) => {dispatch(setRaffleServerUpdate(...props))}
  }
};



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeContainer));